/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { SentryUrl } from '@core/config/Url';

export default () => {
    if (process.env.NODE_ENV !== 'development') {
        Sentry.init({
            dsn              : SentryUrl,
            release          : `furnish@${process.env.REACT_APP_VERSION}`,
            environment      : process.env.REACT_APP_ENV,
            integrations     : [new Integrations.BrowserTracing()],
            tracesSampleRate : 0.5,
        });
        Sentry.configureScope((scope) => {
            scope.setTag('navigator.language', window.navigator.language);
        });
    }
    console.log(`Furnish version: ${process.env.REACT_APP_VERSION}`);
};
